import React, { useState } from 'react';
import { accessor, formatDateToMainUTC, validateOrderFields } from '../../helpers';
import { Input } from '../../components/Input';
import { Select } from '../../components/Select';
import { useDispatch, useSelector } from 'react-redux';
import { Textarea } from '../../components/Textarea';
import { PhoneInput } from '../../components/Input/PhoneInput';
import { FlagInput } from '../../components/Input/FlagInput';
import { AddressInput } from '../../components/Input/AddressInput';
import { Button } from '../../components/Button';
import { createOrder, saveOrderLocal, setNewOrderField } from '../../redux/orderSlice';
import { CLIENT_NOTS, getClientNotify } from '../../redux/notifySlice';

export const AddNewOrder = ({ titles, gridTemplateColumns }) => {
    const advertTypes = useSelector((state) => state.settings.advertTypes);
    const orderTypes = useSelector((state) => state.settings.orderTypes);
    const cities = useSelector((state) => state.settings.orderCities);
    const profiles = useSelector((state) => state.settings.orderProfiles);

    const dispatch = useDispatch();

    const users = useSelector((state) => state.users.list);
    const thisUserId = useSelector((state) => state.auth.id);
    const usersCanCreateOrder = users.filter(accessor.createOrder).filter(u => !u.deleted);

    const isSaveExists = useSelector((state) => state.orders.isSavedOrderExists);
    const savedOrder = JSON.parse(localStorage.getItem('lastSavedOrder'));
    const defaultAddressObj = {
        village: '',
        street: '',
        apartmentNumber: '',
        additional: ''
    };

    const defaultState = {
        advertType: advertTypes[0]._id,
        sourceType: '',
        orderType: orderTypes[0]._id,
        clientName: '',
        orderComment: '',
        city: cities[0]._id,
        address: defaultAddressObj,
        date: '',
        time: '',
        clientPhone: '',
        profileType: profiles[0]._id,
        isProfile: true
    }

    const clientPhoneAccess = titles.find(title => title.key === 'clientPhone');
    const otherCitiesAccess = titles.find(title => title.key === 'city');
    const otherProfilesAccess = titles.find(title => title.key === 'profileType');

    const [orderFields, setOrderFields] = useState({
        advertType: isSaveExists ? savedOrder.advertType : advertTypes[0]._id,
        sourceType: isSaveExists ? savedOrder.sourceType : '',
        orderType: isSaveExists ? savedOrder.orderType : orderTypes[0]._id,
        clientName: isSaveExists ? savedOrder.clientName : '',
        orderComment: isSaveExists ? savedOrder.orderComment : '',
        city: isSaveExists ? savedOrder.city : cities[0]._id,
        address: (isSaveExists && (savedOrder.address.village || savedOrder.address.street || savedOrder.address.apartmentNumber || savedOrder.address.additional)) ? savedOrder.address : defaultAddressObj,
        date: isSaveExists ? savedOrder.date : '',
        time: isSaveExists ? savedOrder.time : '',
        clientPhone: isSaveExists ? savedOrder.clientPhone : '',
        profileType: isSaveExists ? savedOrder.profileType : profiles[0]._id,
        isProfile: typeof savedOrder?.isProfile === 'boolean' ? savedOrder.isProfile : true,
    });

    const [orderOwner, setOrderOwner] = useState(thisUserId);
    const [isCreated, setCreated] = useState(false);

    const changeOrderFieldHandler = (fieldName, value) => {

        setOrderFields((prevValues) => {
            const updatedValues = {
                ...prevValues,
                [fieldName]: value,
            };
            dispatch(saveOrderLocal(updatedValues));
            return updatedValues;
        });
    };

    const handlers = [
        (e) => changeOrderFieldHandler('advertType', e.target.value),
        (e) => changeOrderFieldHandler('sourceType', e.target.value),
        (e) => changeOrderFieldHandler('orderType', e.target.value),
        (e) => changeOrderFieldHandler('clientName', e.target.value),
        (e) => changeOrderFieldHandler('orderComment', e.target.value),
        (e) => changeOrderFieldHandler('city', e.target.value),
        (value) => changeOrderFieldHandler('address', value),
        (e) => changeOrderFieldHandler('date', e.target.value),
        (e) => changeOrderFieldHandler('time', e.target.value),
        (e) => changeOrderFieldHandler('clientPhone', e.target.value),
        (e) => changeOrderFieldHandler('profileType', e.target.value),
        (value) => changeOrderFieldHandler('isProfile', value),
    ];

    const resetOrderHandler = () => {
        dispatch(saveOrderLocal(defaultState));
        setOrderFields(defaultState);
    }
    const dropOrderHandler = () => {
        dispatch(setNewOrderField(false));
    }

    const createOrderHandler = () => {
        const result = validateOrderFields(orderFields, titles);
        if (!result.isOkay) {
            dispatch(getClientNotify({
                data: result,
                action: CLIENT_NOTS.EMPTY_FIELD,
                }),
            );
            return;
        }
        
        const cityUTC = cities.find(c => c._id === orderFields.city).UTC;
        const time = formatDateToMainUTC(orderFields.date, orderFields.time, cityUTC);
        const requestBody = {
            orderData: {
                ...orderFields,
                date: {
                    min: time.min,
                    max: time.max
                }
            },
            orderOwner
        }
        delete requestBody.orderData.time;
        setCreated(true);
        dispatch(createOrder({requestBody, defaultState, setCreated}));
    }

    return (
        <div className="add-order">
            <div className="add-order__body" style={{ gridTemplateColumns }}>
                <Input className="cell" readonly={true} value="auto" />
                <Select
                    className="cell"
                    enums={advertTypes}
                    value={orderFields.advertType}
                    changeHandler={handlers[0]}
                />
                <Input className="cell"
                    placeholder='Представиться'
                    value={orderFields.sourceType}
                    changeHandler={handlers[1]}/>
                <Select
                    className="cell"
                    enums={orderTypes}
                    value={orderFields.orderType}
                    changeHandler={handlers[2]}
                />
                <Input className="cell"
                    placeholder='Имя клиента'
                    value={orderFields.clientName}
                    changeHandler={handlers[3]} />
                <Textarea className="cell dark-theme-bg0"
                    value={orderFields.orderComment}
                    changeHandler={handlers[4]}/>
                {otherCitiesAccess && <Select
                    className="cell"
                    enums={cities}
                    value={orderFields.city}
                    changeHandler={handlers[5]}
                />}
                <AddressInput className="cell"
                    value={orderFields.address}
                    changeHandler={handlers[6]}
                />
                <Input className="cell" type="date"
                    value={orderFields.date}
                    changeHandler={handlers[7]} />
                <Input className='cell'
                    value={orderFields.time}
                    centered={true}
                    placeholder='h-h или h:m-h:m'
                    changeHandler={handlers[8]}
                />
                {clientPhoneAccess && <PhoneInput className="cell"
                    value={orderFields.clientPhone}
                    changeHandler={handlers[9]} />}
                {otherProfilesAccess && <Select
                    className="cell"
                    enums={profiles}
                    value={orderFields.profileType}
                    changeHandler={handlers[10]}
                />}
                <FlagInput className="cell" values={['Профиль', 'Непрофиль']} flag={orderFields.isProfile} changeHandler={handlers[11]} />
                <Input className="cell" readonly={true} value="Не назначена" />
                <div className='add-order__order-owner'>Создать от имени:
                    <Select
                    className="cell"
                    enums={usersCanCreateOrder}
                    value={orderOwner}
                    changeHandler={(evt) => setOrderOwner(evt.target.value)}
                />
                </div>
            </div>
            <div className="add-order__buttons">
                <Button size='small' disabled={isCreated} onClick={createOrderHandler} text='создать'/>
                <Button size='small' onClick={dropOrderHandler} text='убрать'/>
                <Button size='small' onClick={resetOrderHandler} text='сброс'/>
            </div>
        </div>
    );
};
